import React from "react";
import { Button, Container, TextField } from "@mui/material";

function Search({ ...props }) {
  return (
    <TextField
      variant="outlined"
      label="Trial ID"
      type="search"
      sx={{ marginBottom: "2rem" }}
      {...props}
    ></TextField>
  );
}

export default Search;
